import { getPaymentMethodIcon } from '@belong/common';
import { Image } from '@belong/ui';

type PaymentMethodIconProps = {
  paymentMethod?: string | null;
  bankName?: string | null;
  cardType?: string | null;
  className?: string;
  imageWidth?: number;
  imageHeight?: number;
};

// Unified S3 payment-method icon renderer. Routes through @belong/common's
// getPaymentMethodIcon, which returns:
//   - ACH:        bank-specific S3 SVG by bankName, falling back to generic ACH
//   - CreditCard: brand-specific S3 SVG by cardType, falling back to generic card
//   - Other methods (Check / PayPal / Wire / Other): generic S3 SVGs
export function PaymentMethodIcon({
  paymentMethod,
  bankName,
  cardType,
  className,
  imageWidth = 46,
  imageHeight = 30,
}: PaymentMethodIconProps) {
  const normalizedMethod = paymentMethod ?? undefined;
  const secondArg = normalizedMethod === 'Ach' ? bankName : cardType;
  const url = getPaymentMethodIcon(
    normalizedMethod,
    (secondArg ?? '') as string,
  );

  // `@belong/ui`'s Image forces `w-full h-full` on the underlying <img>, and
  // this app runs Tailwind with `important: true`, so those classes win over
  // an inline width/height. Constrain the size on a wrapping box instead so the
  // image fills it at a fixed size everywhere it's used.
  return (
    <span
      className={className}
      style={{
        display: 'inline-block',
        flexShrink: 0,
        width: imageWidth,
        height: imageHeight,
      }}
    >
      <Image src={url} alt="" aria-hidden style={{ objectFit: 'contain' }} />
    </span>
  );
}
